import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useAdminStore, useKnowledgeStore } from '@getmayday/vue-modules';
import { computeNavigationLanguage } from '../utils/lang';

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  if (to.name !== 'index' || to.query.silent) return next();
  const knowledgeStore = useKnowledgeStore();
  const configStore = useConfigStore();
  const { knowledgeId, selectedLanguage } = storeToRefs(knowledgeStore);
  const { lastEntityRoute } = storeToRefs(configStore);
  let force = to.query.force || '0';
  // In case of a focus tab and the current route is not home/knowledge
  if (
    to.query.focusTab === '1' &&
    from.meta.tabIndex &&
    from.meta.tabIndex > 0
  ) {
    return next();
  }

  // In case we have a last path knowledge navigation
  if (lastEntityRoute.value?.path && force === '0') {
    const { query } = lastEntityRoute.value;
    const { query: toQuery } = to;
    return next({
      ...lastEntityRoute.value,
      query: {
        ...query,
        noSave: '1',
        ...(toQuery.queryText ? { queryText: toQuery.queryText } : {}),
      },
    });
  }

  // If there is no focus knowledge
  if (!knowledgeId.value) {
    try {
      force = '1';
      knowledgeId.value = await configStore.initKnowledge();

      if (!knowledgeId.value) throw 'MISSING FOCUS KNOWLEDGE';
    } catch {
      // logout
      configStore.logout();
      return next();
    }
  }

  const adminStore = useAdminStore();
  const { contentLanguage } = storeToRefs(adminStore);
  const { getKnowledgeByValue } = knowledgeStore;

  const knowledge = getKnowledgeByValue(knowledgeId.value);
  const lang = computeNavigationLanguage(
    knowledge,
    contentLanguage.value,
    selectedLanguage.value,
  );

  next({
    path: `/${lang}/knowledges/${knowledgeId.value}`,
    query: {
      ...to.query,
      force,
    },
  });
};
